import React, { Fragment } from 'react';
import classNames from 'classnames';

import { getSportKey } from 'app/lib/betting/sport-utils';
import type { TournamentWithHierarchyBySportId } from 'app/redux/betting-presentation/grid/selectors';
import EmptyGame from 'app/widgets/EmptyGame';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import GridHeader from './GridHeader';
import TournamentTable from './TournamentTable';

import styles from './SportsGrid.module.scss';

type SportsGridProps = {
  tournamentsBySportId: TournamentWithHierarchyBySportId;
  liveEntityLoading: boolean;
  liveEntityRequested: boolean;
};

export const SportsGrid = ({
  tournamentsBySportId,
  liveEntityLoading,
  liveEntityRequested,
}: SportsGridProps) => {
  if (tournamentsBySportId.size === 0 && !liveEntityLoading && liveEntityRequested) {
    return <EmptyGame />;
  }

  const sportIds = Array.from(tournamentsBySportId.keys());

  return (
    <ErrorBoundary>
      <div data-test="content-container"
           className={styles.content}>
        {sportIds.map((sportId) => {
          const matchIdsByTournamentId = tournamentsBySportId.get(sportId);
          const tournamentIds = Array.from(matchIdsByTournamentId?.keys() || []);
          const _sportContainerClassName = classNames(
            getSportKey(sportId),
            styles.sportContainer,
          );

          return (
            <Fragment key={sportId}>
              <GridHeader sportId={sportId}
                          shouldBeLink />

              <div className={_sportContainerClassName}>
                {tournamentIds.map((tournamentId, index) => (
                  <TournamentTable key={tournamentId}
                                   sportId={sportId}
                                   tournamentId={tournamentId}
                                   showGridColumns={index === 0}
                                   matchIds={matchIdsByTournamentId?.get(tournamentId)?.matchIds} />
                ))}
              </div>
            </Fragment>
          );
        })}
      </div>
    </ErrorBoundary>
  );
};
